import { Props_SnippetAnchorLinks} from "./AnchorLinks.props";

const SnippetAnchorLinks = (props: Props_SnippetAnchorLinks ) => {
 const { anchorTitle, repeatable_buttons } = props;
    const anchorTitleClass = "snippet-anchor-links__title " + (anchorTitle?.showTitle?.value === "true" ? "" : "accessible-heading");


    return (
        <section className="snippet-anchor-links">
            <div className="snippet-anchor-links__container">
                {anchorTitle?.text?.value && <h2 className={anchorTitleClass}>
                    {anchorTitle.text.value}
                </h2>}
                <div className="snippet-anchor-links__row-container">
                    {repeatable_buttons.map((button, index) => (
                        <a
                            key={"anchor-link-" + index}
                            href={button?.linkhref?.value}
                            className="snippet-anchor-links__link attrax-button-octonary"
                            aria-label={button?.linktext?.value}
                        >
                            {button?.linktext?.value}
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default SnippetAnchorLinks;